// Autenticação — UX só-senha (login único do time).
//
// Fluxo:
//   * No boot: getSession(). Se não houver sessão, mostra o overlay de login
//     (apenas campo de senha). O e-mail vem fixo de VITE_PANEL_EMAIL.
//   * signInWithPassword({ email: PANEL_EMAIL, password }). Sucesso → esconde
//     overlay e segue para a carga do app. Erro → mensagem na tela.
//   * Logout (botão no rodapé da sidebar) → signOut() → mostra overlay de novo.
//
// A área de dados (.shell) fica oculta até autenticar.
import { supabase, PANEL_EMAIL } from './lib/supabase.js'

// Cria (uma única vez) o overlay de login e devolve seus elementos.
function montarOverlay() {
  let bg = document.getElementById('loginOverlay')
  if (bg) return bg

  bg = document.createElement('div')
  bg.id = 'loginOverlay'
  bg.className = 'login-bg'
  bg.innerHTML =
    '<form class="login-card" id="loginForm" autocomplete="off">' +
    '<div class="login-logo"><img src="/logo.png" alt="Tráfego VG"></div>' +
    '<h1>Tráfego VG</h1>' +
    '<p>Operação Meta Ads — acesso restrito</p>' +
    '<input type="password" id="loginSenha" placeholder="Senha de acesso" autocomplete="current-password" required>' +
    '<button type="submit" class="btn pri" id="loginBtn">Entrar</button>' +
    '<div class="login-err" id="loginErr"></div>' +
    '</form>'
  document.body.appendChild(bg)
  return bg
}

// Mostra/esconde o overlay e a área de dados.
function mostrarLogin(visivel) {
  const bg = montarOverlay()
  bg.classList.toggle('open', visivel)
  const shell = document.querySelector('.shell')
  if (shell) shell.classList.toggle('hidden', visivel)
}

// Liga o submit do formulário de login.
function ligarFormulario(onSucesso) {
  const bg = montarOverlay()
  const form = bg.querySelector('#loginForm')
  const senha = bg.querySelector('#loginSenha')
  const btn = bg.querySelector('#loginBtn')
  const err = bg.querySelector('#loginErr')

  form.onsubmit = async ev => {
    ev.preventDefault()
    err.textContent = ''
    btn.disabled = true
    btn.textContent = 'Entrando...'
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: PANEL_EMAIL,
        password: senha.value
      })
      if (error) throw error
      senha.value = ''
      mostrarLogin(false)
      await onSucesso()
    } catch (e) {
      err.textContent = 'Senha incorreta ou falha de acesso. Tente novamente.'
    } finally {
      btn.disabled = false
      btn.textContent = 'Entrar'
    }
  }
}

// Inicializa a autenticação. Chama onLogin() sempre que houver sessão válida.
// Retorna após decidir o estado inicial (logado ou exibindo overlay).
export async function initAuth(onLogin) {
  ligarFormulario(onLogin)

  const { data } = await supabase.auth.getSession()
  if (data.session) {
    mostrarLogin(false)
    await onLogin()
  } else {
    mostrarLogin(true)
    const senha = document.getElementById('loginSenha')
    if (senha) senha.focus()
  }
}

// Faz logout: encerra a sessão e reexibe o overlay de login.
export async function logout() {
  await supabase.auth.signOut()
  mostrarLogin(true)
  const senha = document.getElementById('loginSenha')
  if (senha) senha.focus()
}
